import { render, staticRenderFns } from "./HeaderTickspeedInfo.vue?vue&type=template&id=6034dad0&scoped=true&"
import script from "./HeaderTickspeedInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderTickspeedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6034dad0",
  null
  
)

export default component.exports